export const config = {
    apiKey: "AIzaSyBty6_Ukx0dQbfuR-OZbVg9Qs-9fBb5O3I",
    authDomain: "chat-16a72.firebaseapp.com",
    databaseURL: "https://chat-16a72-default-rtdb.firebaseio.com",
    projectId: "chat-16a72",
    storageBucket: "chat-16a72.appspot.com",
    messagingSenderId: "681471094134",
    appId: "1:681471094134:web:a6c8c10cc6bc48c2729e57"
}
